import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-top-list',
  templateUrl: './top-list.component.html',
  styleUrls: ['./top-list.component.scss']
})
export class TopListComponent implements OnInit {

  constructor(
    public dialgoRef: MatDialogRef<TopListComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { }

  ngOnInit(): void {
    this.dialgoRef.addPanelClass('top-list-dialog');
  }

  public getINRFormat(count: number) {
    const format = this.identifyNumber(count);
    if(true) {
      // return +count.toString().slice(0, 3) / 100;
      const num = count / 10000000
      return `${num.toFixed(2)} ${format}`
    }else {
      return `${+count.toString().slice(0, 5) / 100} ${format}`;
    }
  }

  identifyNumber(number:any) {
    if (number >= 10000000) {
        return "Crores";
    } else if (number >= 100000) {
        return "lac";
    } else {
        return "";
    }
  }


}
